Ext.ns('mx.plugin');

mx.plugin.RealCheck = function(config) {
    Ext.apply(this, config || {});
};
Ext.extend(mx.plugin.RealCheck, Ext.util.Observable, {
    init: function(target) {
        Ext.apply(target, {
            getValue: function() {
                return mx.Util.processNumberField(Ext.form.TextField.prototype.getValue.apply(this, arguments));
            },
            validate: function() {
                var invalid = isNaN(this.getValue());
                if (invalid) {
                    this.markInvalid(Ext.form.Field.invalidText);
                } else {
                    this.clearInvalid();
                }
                return !invalid;
            },
        });
    },
});
